import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Badge
} from "reactstrap";
import {
  Club,
  Configuracion,
  LoadingStates
} from "../horariosClubesComponentTypes";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  clubes: Club[];
  configuraciones: Configuracion[];
  configuracionEditando: string | null;
  clubesSeleccionados: string[];
  onClubChange: (clubIds: string[]) => void;
  onGuardar: () => void;
  loadingStates: LoadingStates;
  isAnyOperationInProgress: () => boolean;
  onSeleccionarTodosClubes: () => void;
}

const ModalEditarClubes: React.FC<Props> = ({
  isOpen,
  toggle,
  clubes,
  configuraciones,
  configuracionEditando,
  clubesSeleccionados,
  onClubChange,
  onGuardar,
  loadingStates,
  isAnyOperationInProgress,
  onSeleccionarTodosClubes
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Editar Clubes</ModalHeader>
      <ModalBody>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Label>Selección de clubes</Label>
          <Button color="danger" size="sm" onClick={onSeleccionarTodosClubes}>
            Seleccionar Todos
          </Button>
        </div>
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            border: "1px solid #dee2e6",
            padding: "10px",
            borderRadius: "4px"
          }}
        >
          {clubes.map((club: any) => {
            /*             const otrasConfiguraciones = configuraciones.filter(
              c => c.configuracionId.toString() !== configuracionEditando
            );
            const clubesUsados = otrasConfiguraciones.reduce(
              (acc, config) => {
                return acc.concat(
                  config.clubes.map((c: any) => c.id.toString())
                );
              },
              [] as string[]
            );
            const estaEnUso = clubesUsados.includes(club.id.toString()); */

            return (
              <FormGroup check key={club.id} className="mb-1">
                <Label check>
                  <Input
                    type="checkbox"
                    style={{
                      accentColor: "#dc3545"
                    }}
                    checked={clubesSeleccionados.includes(club.id.toString())}
                    /* disabled={estaEnUso} */
                    onChange={e => {
                      if (e.target.checked) {
                        onClubChange([
                          ...clubesSeleccionados,
                          club.id.toString()
                        ]);
                      } else {
                        onClubChange(
                          clubesSeleccionados.filter(
                            id => id !== club.id.toString()
                          )
                        );
                      }
                    }}
                  />
                  <small>
                    {club.nombre} - {club.claveCorta}
                  </small>
                  {/* {estaEnUso && (
                    <Badge
                      color="warning"
                      className="ml-2"
                      style={{ fontSize: "10px" }}
                    >
                      En uso
                    </Badge>
                  )} */}
                </Label>
              </FormGroup>
            );
          })}
        </div>
        <small className="text-muted mt-2 d-block">
          {clubesSeleccionados.length} seleccionados
        </small>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={toggle}
          disabled={isAnyOperationInProgress()}
        >
          Cancelar
        </Button>
        <Button
          color="danger"
          onClick={onGuardar}
          disabled={isAnyOperationInProgress()}
        >
          {loadingStates.updating ? <>Actualizando...</> : "Guardar Clubes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalEditarClubes;
